export default __webpack_public_path__ + "static/media/cv_justin_katasi.9e130597.pdf";